import { 
  Suspense, 
  lazy, 
  useMemo, 
}                                   from 'react';
import Home                         from 'pages/home';
import { connect }                  from 'react-redux';
import { reducerType }              from 'reducer';
import Loader                       from 'components/Loader';
import { pagesWithGrid }            from 'utils/constants';
import { pageStateType }            from 'types'
import { colors }                   from 'utils/colors'
import { makeStyles }               from "makeStyles";

const About     = lazy(() => import('pages/about'));
const Apps      = lazy(() => import('pages/apps'));
const Tutorials = lazy(() => import('pages/tutorials'));

//const allRouts = ['apps', 'about', 'appPage', 'tutorials']


const useStyles = makeStyles()(() => ({
    root: {
        minHeight:       '100vh',
        minWidth:        '100vw',
        maxHeight:       '100vh',
        maxWidth:        '100vw',
        backgroundColor: '#FFF',
        overflow:        'hidden',
        transition:      'opacity 0.6s',
    },
    LoaderPage: {
      position:        'fixed',
      top:             0,
      left:            0,
      minHeight:       '100vh',
      minWidth:        '100vw',
      maxHeight:       '100vh',
      maxWidth:        '100vw',
      backgroundColor: '#FFF',
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      textAlign:       'center',
      flexFlow:        'column',
    },
    fallBack: {
      position:        'absolute',
      left:            0,
      height:         '100vh',
      width:          '100vw',
      backgroundColor: '#FFF',
      overflow:        'hidden',
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
    },
    submitButton: {
      width:           300,
      height:          50,
      fontSize:        20,
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      textAlign:       'center',
      backgroundColor: colors.primary,
      color:           '#FFF',
      fontWeight:      'bold',
      cursor:          'pointer',
      boxShadow:       '2px 4px 9px rgba(0,0,0,0.1)',
      position:        'absolute',
      left:            '50%',
      marginTop:       20,
      transform:       'translate(-50%, 0%)',
      '&:hover': {
        opacity: 0.5
      }
    }
}))

type rootPagesProps = {
  pageState:              pageStateType;
  showTeacherUrlModal:    () => void;
}


const RootPages: React.FC<rootPagesProps> = ({
  pageState,
  showTeacherUrlModal,
}) => {


const { classes } = useStyles();

  const showGrid = useMemo(() => {
    return pagesWithGrid.includes(pageState.page)
  },[pageState])


  return (
    <>
    <div className = { classes.root }>
      {
          pageState.page === 'Root' && <Home/> 
      }
      {
          showGrid
          &&
          <Suspense 
                fallback = {
                  <div className = { classes.fallBack }>
                    <Loader/>
                  </div>
                }
          >
                 <Apps showTeacherUrlModal = { showTeacherUrlModal }/>
          </Suspense>
      }
      {
          pageState.page === 'about'
          &&
          <Suspense 
                fallback = {
                  <div className = { classes.fallBack }>
                    <Loader/>
                  </div>
                }
          >
             <About/>
          </Suspense>
      }
      {
         ['tutorials', 'selfTeachVideo', 'linksVideo'].includes(pageState.page)
         &&
         <Suspense 
                fallback = {
                  <div className = { classes.fallBack }>
                    <Loader/>
                  </div>
                }
          >
            <Tutorials/>
         </Suspense>
      }
    </div>
    </>
  );
}




const mapStateToProps = (reducer: reducerType) => {



  return {
    pageState: reducer.page,
}};


export default connect(mapStateToProps)(RootPages);
